/* oxlint-disable */
/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.config file > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/

import {AppFullscreen,Dialog,Notify,LoadingBar,Loading,LocalStorage,Cookies} from 'quasar'

export default { config: {"dark":false,"loadingBar":{"position":"bottom","size":"2px","color":"primary"},"loading":{}},plugins: {AppFullscreen,Dialog,Notify,LoadingBar,Loading,LocalStorage,Cookies} }
